<div class="flex-modal professional">
  <div class="modal-header" *ngIf="config.title">
    <h4 class="modal-title">{{config.title}}</h4>
  </div>

  <ng-container *ngIf="config.body">

    <ng-container *ngIf="isTemplateRef | thunk : config.body else stringBody">
      <ng-template [ngTemplateOutlet]="config.body"></ng-template>
    </ng-container>

    <ng-template #stringBody>
      <div class="modal-body">
        <p>{{config.body}}</p>
      </div>
    </ng-template>

  </ng-container>


  <div class="modal-footer" *ngIf="config.rejectButtonText || config.successButtonText">
    <button
      *ngIf="config.rejectButtonText"
      type="button"
      class="btn btn-default"
      (click)="onRejectClick()"
    >{{config.rejectButtonText}}
    </button>

    <button
      *ngIf="config.successButtonText"
      type="button"
      class="btn btn-primary"
      (click)="onSuccessClick()"
    >{{config.successButtonText}}
    </button>
  </div>
</div>
